// extracted by mini-css-extract-plugin
export var leftAlign = "_1k-2";
export var popper = "_1k-0";
export var subtitle = "_1k-1";